import { render, staticRenderFns } from "./OpenVPNClientShow.vue?vue&type=template&id=7323a994&"
import script from "./OpenVPNClientShow.vue?vue&type=script&lang=js&"
export * from "./OpenVPNClientShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports